<template>
  <div style="text-align: left;">
    <section style="list-style-type: none;" v-if="this.onlyDash != null & this.canCreate == null">

      <div v-if="this.onlyDash === true">
        <b-dropdown-item :disabled="hasNoDash" v-for="dash, index in options.dashboards" :key="'dash' + index"
          @click="onShowDashboard(dash)"><svg v-if="hasIcon" style="margin-right:10px"
            xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <g fill="none">
              <path stroke="currentColor" stroke-width="1.5"
                d="M5.5 8.757C5.5 6.958 7.067 5.5 9 5.5s3.5 1.458 3.5 3.257c0 1.785-1.117 3.868-2.86 4.613a1.64 1.64 0 0 1-1.28 0c-1.743-.745-2.86-2.828-2.86-4.613Z" />
              <path stroke="currentColor" stroke-linecap="round" stroke-width="1.5"
                d="m14 14l6.5 6.5M14 14l-7.605 7.605M14 14l2-2m5.607-5.606L19 9" />
              <path fill="currentColor" d="M10 9a1 1 0 1 1-2 0a1 1 0 0 1 2 0" />
              <path stroke="currentColor" stroke-linecap="round" stroke-width="1.5"
                d="M2 12c0 4.714 0 7.071 1.464 8.535C4.93 22 7.286 22 12 22s7.071 0 8.535-1.465C22 19.072 22 16.714 22 12s0-7.071-1.465-8.536C19.072 2 16.714 2 12 2S4.929 2 3.464 3.464c-.973.974-1.3 2.343-1.409 4.536" />
            </g>
          </svg> {{ dash.name }}</b-dropdown-item>
      </div>
      <div v-else-if="this.onlyDash === false && options.dashboards.length != 0">
        <b-dropdown-group header="Dashboards">
          <b-dropdown-item :disabled="hasNoDash" v-for="dash, index in options.dashboards" :key="'dash' + index"
            @click="onShowDashboard(dash)"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
              viewBox="0 0 24 24">
              <g fill="none" stroke="currentColor" stroke-width="1">
                <rect width="18.5" height="18.5" x="2.75" y="2.75" stroke-width="1.5" rx="6" />
                <path stroke-linecap="round" stroke-width="1.6"
                  d="M7.672 16.222v-5.099m4.451 5.099V7.778m4.205 8.444V9.82" />
              </g>
            </svg> {{ dash.name }}</b-dropdown-item>
        </b-dropdown-group>
      </div>

    </section>
    <section style="list-style-type: none;" v-if="this.canCreate != null">

      <div>
        <b-dropdown-item :disabled="hasNoDash" v-for="dash, index in options.dashboards" :key="'dash' + index"
          @click="onCreateDashboard(dash)"><svg v-if="hasIcon" style="margin-right:10px"
            xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <g fill="none">
              <path stroke="currentColor" stroke-width="1.5"
                d="M5.5 8.757C5.5 6.958 7.067 5.5 9 5.5s3.5 1.458 3.5 3.257c0 1.785-1.117 3.868-2.86 4.613a1.64 1.64 0 0 1-1.28 0c-1.743-.745-2.86-2.828-2.86-4.613Z" />
              <path stroke="currentColor" stroke-linecap="round" stroke-width="1.5"
                d="m14 14l6.5 6.5M14 14l-7.605 7.605M14 14l2-2m5.607-5.606L19 9" />
              <path fill="currentColor" d="M10 9a1 1 0 1 1-2 0a1 1 0 0 1 2 0" />
              <path stroke="currentColor" stroke-linecap="round" stroke-width="1.5"
                d="M2 12c0 4.714 0 7.071 1.464 8.535C4.93 22 7.286 22 12 22s7.071 0 8.535-1.465C22 19.072 22 16.714 22 12s0-7.071-1.465-8.536C19.072 2 16.714 2 12 2S4.929 2 3.464 3.464c-.973.974-1.3 2.343-1.409 4.536" />
            </g>
          </svg> {{ dash.name }}</b-dropdown-item>
      </div>

    </section>
  </div>
</template>

<script>
import Vue from 'vue'
import jwt from 'jwt-simple';
import { Auth } from '../../service/Auth'
import { Layer } from '../../service/Layer'
import { Setting } from '../../service/Setting'
export default {
  name: 'DashboardMenu',
  props: {
    canCreate: {
      type: Boolean,
      default: null,
      require: false
    },
    onlyDash: {
      type: Boolean,
      default: null,
      require: false
    },
    isCreate: {
      type: Boolean,
      default: false,
      require: true
    },
    requestId: {
      type: String,
      require: false,
      default: ''
    },
    hasIcon: {
      type: Boolean,
      default: true,
      require: false
    },
    legend: {
      type: Object,
      require: false
    },
    legendVariable: {
      type: Object,
      require: false
    }
  },
  data() {
    return {
      layerInformation: {},
      layerService: Layer.build({}),
      authservice: Auth.build({}),
      hasNoDash: true,
      isOpeningDashboard: false,
      showMenu: false,
      options: {
        dashboards: []
      },
      dictContextType: {
        'Area de Influência': 1,
        'userdraw': 2,
        'joindraw': 3,
        'multi-buffer': 4,
        'point': 5,
        'polygon': 6,
        'route': 7,
      },
      settingService: Setting.build({}),

    };
  },
  mounted: async function () {
    console.log('### DashboardMenu mounted ###')
    const enviromentName = Vue.prototype.$foundation.getEnvironmentName();
    const dashboards = await this.authservice.getApplication(enviromentName);
    if (dashboards.status == 404 || dashboards.data.length == 0)
      this.hasNoDash = true
    else if (dashboards.status == 200 && dashboards.data.length != 0) {
      this.hasNoDash = false
      await this.getLayer(this.requestId);

      this.options.dashboards = dashboards.data.filter(item => {
        const context = item.config.context || [];
        let contextLayer
        if (this.layerInformation.class == 'userdraw') {
          contextLayer = this.dictContextType['userdraw']
          contextLayer = this.dictContextType[this.layerInformation.type] || contextLayer;
        } else {
          let isPolygon = this.isPolygon(this.layerInformation.object)
          if (isPolygon)
            contextLayer = this.dictContextType['polygon'];
          else
            contextLayer = this.dictContextType['point'];

        }


        return item.config.type === 3 &&
          (context.length === 0 || context.includes(contextLayer));
      });


      //  this.options.dashboards = dashboards.data.filter(item => item.config.type === 3);



    }
  },
  methods: {
    async getLayer(layerUid) {
      if (!layerUid.length > 0) return
      await this.layerService.getLayerByUid(layerUid).then(async res => {
        if (res.status !== 200) {
          console.error('Erro ao obter informações da camada:', res);
          return;
        }

        this.layerInformation = {
          id: res.data.objectid,
          uid: res.data.gdIdEvent,
          name: res.data.cAlias,
          class: res.data.cClass,
          type: res.data.cClass,
          object: res.data
        }
        if (this.layerInformation.type === 'userdraw') {
          if (
            res && res.data && res.data.jbData &&
            res.data.jbData.config && res.data.jbData.config.reference &&
            res.data.jbData.config.reference.source
          ) {
            let source = res.data.jbData.config.reference.source
            this.layerInformation.type = (typeof source === 'string') ? source : 'userdraw';
          }
        }
      })
    },
    onCreateDashboard(obj) {
      const self = this
      self.$emit('onCreateDash', obj)
    },
    async onShowDashboard(obj) {
      if (this.isOpeningDashboard) return; // Evita múltiplos cliques simultâneos
      this.isOpeningDashboard = true;

      try {
        const url = obj.baseUrl
        const requestId = this.requestId
        const token = Vue.prototype.$foundation.getUserToken();
        const dashCustomPayload = obj.config.payload || null
        function removeBearer(token) {
          return token.replace('Bearer ', '');
        }

        let superKey = await this.settingService.getSettings('dashboard_superkey')
        // Verifica se o resultado é null ou um objeto/array vazio
        if (!superKey || (Array.isArray(superKey) && superKey.length === 0) || (typeof superKey === 'object' && Object.keys(superKey).length === 0)) {
          throw new Error('Erro: valor de chave dashboard inválido ou vazio');
        }
        if (
          !superKey[0] ||
          !superKey[0].jbValue ||
          typeof superKey[0].jbValue.superKey === 'undefined'
        ) {
          throw new Error('Erro: Chave dashboard não está disponível');
        }

        superKey = superKey[0].jbValue.superKey;
        const SUPER_SECRET = superKey;
        let payload = {
          guide: requestId,
          token: removeBearer(token),
          exp: Math.floor(Date.now() / 1000) + 60 * 60, // Expira em 1 hora
        };
        if (dashCustomPayload != null)
          payload = Object.assign({}, payload, dashCustomPayload);


        // Gerando o token JWT
        const userData = {
          userId: Vue.prototype.$foundation.getTokenClaims()['UserId'],          // ID do usuário no seu banco
          environmentId: Vue.prototype.$foundation.getEnvironmentId(),
          url: url // ID do ambiente/cliente que ele logou
        };
        this.$gtag.event("request_dashboard", {
          event_category: "Interações Plataforma",
          event_label: "Abertura de dashboard",
          value: 1,
          ...userData
        });



        const jwtToken = jwt.encode(payload, SUPER_SECRET, 'HS256');
        const dashboardUrl = `${url}/?token=${jwtToken}`;

        window.open(dashboardUrl, '_blank');
      } finally {
        setTimeout(() => {
          this.isOpeningDashboard = false; // Reseta após um tempo para evitar múltiplas chamadas seguidas
        }, 1000); // Tempo de debounce
      }
    },
    showDashboard: async function (layerId, type, dash = null) {
      const self = this
      layerId = this.legendVariable.layerId
      self.$bus.$emit('showTablePivotLegend', { "layerId": layerId, "type": type, "dash": dash })
    },
    showTablePivot: async function (layerId, type) {
      const self = this
      layerId = this.legendVariable.layerId
      self.$bus.$emit('closeToc')
      self.$bus.$emit('closeLayerOptions', 'Toc')
      const $timeout = d => new Promise(r => setTimeout(r, d));
      await $timeout(1000)
      self.$bus.$emit('showTablePivotLegend', { "layerId": layerId, "type": type })

    },
  }
};
</script>

<style scoped>
.context-menu {
  position: absolute;
  background: white;
  border: 1px solid #ccc;
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.2);
  padding: 10px;
  z-index: 1000;
  border-radius: 5px;
}
</style>
